"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarViewTypePicker = void 0;
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importDefault(require("react"));
const useOpScheduleCalendar_1 = __importDefault(require("../OpScheduleCalendarController/useOpScheduleCalendar"));
const useOpScheduleCalendarActions_1 = __importDefault(require("../OpScheduleCalendarController/useOpScheduleCalendarActions"));
const CalendarViewType_1 = __importDefault(require("./CalendarViewType"));
function CalendarViewTypePicker() {
    const { loading, calendarView } = (0, useOpScheduleCalendar_1.default)();
    const { doChangeCalendarView } = (0, useOpScheduleCalendarActions_1.default)();
    const handleClick = (0, useCallforward_1.default)(v => () => doChangeCalendarView(v), [doChangeCalendarView]);
    return (react_1.default.createElement(Horizontal_1.default, null,
        react_1.default.createElement(Button_1.default, { noEvents: loading, background: calendarView !== CalendarViewType_1.default.MONTH, onClick: handleClick(CalendarViewType_1.default.MONTH), label: lib_i18n_1.default.t('month') }),
        react_1.default.createElement(Button_1.default, { noEvents: loading, background: calendarView !== CalendarViewType_1.default.WEEK, onClick: handleClick(CalendarViewType_1.default.WEEK), label: lib_i18n_1.default.t('week') })));
}
exports.CalendarViewTypePicker = CalendarViewTypePicker;
exports.default = CalendarViewTypePicker;
